import React from 'react';
import { format } from 'date-fns';

import styles from './MessageList.module.scss';

export type MessageListItem = {
    smsTime: string;
    smsDate: string;
    speakerLabel: string;
    text: string;
    direction: 'inbound' | 'outbound';
};

export interface MessageListProps {
    items: MessageListItem[];
    className?: string;
    emptyMessage?: string;
}

/**
 * Renders a list of message bubbles with transcript-like styling (speaker label + text).
 * Reusable for SMS details, transcript-style content, etc.
 */
export const MessageList: React.FC<MessageListProps> = ({ items, className, emptyMessage = 'No messages' }) => {
    if (!items.length) {
        return (
            <div className={`${styles.container} ${className || ''}`}>
                <div className={styles.text} style={{ color: 'var(--gray-700)', fontStyle: 'italic' }}>
                    {emptyMessage}
                </div>
            </div>
        );
    }

    return (
        <div className={`${styles.container} ${className || ''}`}>
            {items.map((item, index) => (
                <div
                    key={`${index}-${item.speakerLabel}`}
                    className={`${styles.item} ${item.direction === 'outbound' ? styles.outbound : styles.inbound}`}
                >
                    <div className={styles.header}>
                        <span className={styles.speaker}>{item.speakerLabel}</span>
                        <span
                            className={styles.speaker}
                        >{`${format(new Date(item.smsDate), 'MMMM d')}, ${item.smsTime}`}</span>
                    </div>
                    <p className={styles.text}>{item.text}</p>
                </div>
            ))}
        </div>
    );
};
